import styled from 'styled-components'

export const Container = styled.div<{ backgroundColor: string }>`
  padding-top: 12px;
  background: ${(props) => props.backgroundColor};
  border: 2px solid ${(props) => props.backgroundColor};
  border-radius: 4px;
`

export const PlayerBar = styled.div<{ backgroundColor: string }>`
  background: ${(props) => props.backgroundColor};
  padding: 12px;
  padding-right: 32px;
  display: flex;
  align-items: center;
  gap: 12px;
`

export const ProgressBarWrapper = styled.div`
  flex: 1;
  height: 4px;
  background: #dde3ea;
  border-radius: 2px;
  cursor: pointer;
  position: relative;
`

export const ProgressBar = styled.div<{ width: number }>`
  width: ${(props) => props.width}%;
  height: 100%;
  background: #1a6fb5;
  border-radius: 2px;
  pointer-events: none;
`
